<template>
    <v-dialog v-model="dialog" max-width="500" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ editMode ? $t('common.edit') : $t('common.add') }} {{ $t(`common.group`) }}
            </v-card-title>
            <v-card-text class="mt-3">
                    <kimsa-text-field
                        :placeholder="$t('common.name')"
                        @change="name = $event"
                        :value="name"
                    />
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-btn block depressed x-large color="primary" class="normal-btn no-radius black--text" :disabled="!valid"
                       @click="save" :loading="loading">
                    {{ editMode ? $t('common.edit') : $t('common.add') }}
                </v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import {mapMutations, mapState} from "vuex";
import {db, FieldValue} from "@/utils/Firebase";
export default {
    name: "CreateGroupStudentsDialog",
    components: {KimsaTextField},
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            name: '',
            loading: false,
            group: null,
            editMode: false,
        }
    },
    computed: {
        ...mapState(['dialogActive','secondDialogActive']),
        valid(vm = this) {
            return vm.name.length >= 3
        }
    },
    methods: {
        ...mapMutations(['setDialogActive','setSecondDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.isSecondDialog ? vm.setSecondDialogActive(true) : vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.isSecondDialog ? vm.setSecondDialogActive(false) : vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.name = ''
            vm.group = null
            vm.editMode = false
        },
        loadGroup(group) {
            const vm = this
            vm.editMode = true
            vm.name = group.name
            vm.group = group
            vm.show()
        },
        async save() {
            const vm = this
            vm.loading = true

            if(vm.editMode) {
                await db.collection('groups').doc(vm.group.id).update({
                    name: vm.name,
                })
                vm.toast(vm.$t('common.group_edited'))
            } else {
                await db.collection('groups').add({
                    coachId: vm.currentUser.uid,
                    name: vm.name,
                    students: [],
                })

                await db.collection('users').doc(vm.currentUser.uid).update({
                    groupsQuantity: FieldValue.increment(1),
                })

                vm.toast(vm.$t('common.group_added'))
            }

            vm.loading = false
            vm.hide()
        }
    },
    watch: {
        dialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
        secondDialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
    }
}
</script>

<style scoped>

.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}

</style>